import script from "./addOrEditPlayAuth.vue?vue&type=script&lang=ts&setup=true"
export * from "./addOrEditPlayAuth.vue?vue&type=script&lang=ts&setup=true"

import "./addOrEditPlayAuth.vue?vue&type=style&index=0&id=2517df8a&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2517df8a"]])

export default __exports__